<template>
  <div class="i-seat-multi-picker">
    <i-multi-picker
      ref="picker"
      :label-counter="$t('common.seatCounter')"
      :label="resolvedLabel"
      :value="value"
      :fetch-options="fetchSeats"
      :disabled="disabled"
      :placeholder="resolvedPlaceholder"
      option-label="name"
      option-value="id"
      @input="$val => $emit('input',$val)"
      @open="onOpen"
      @search-change="onHighlight"
      @keydown="onKeydown"
    />
  </div>
</template>

<script>
import {list as listMicrosoftSeats} from "@/services/api/app/seat-management/seat";
import {list as listGoogleSeats} from "@/services/api/app/google/seat-management/seat";
import {list as listDropboxSeats} from "@/services/api/app/dropbox/seat-management/seat"
import {list as listBoxSeats} from "@/services/api/app/box/seat-management/seat";
import {list as listEntraIdSeats} from "@/services/api/app/entraId/seat-management/seat";
import IMultiPicker from "@/components/common/forms/IMultiPicker";
import Multiselect from "vue-multiselect";

export default {
  name: 'ISeatMultiPicker',
  emits: ['input'],
  components: {Multiselect, IMultiPicker},
  props: {
    value: {},
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    providerTenant: {
      type: String,
      default: 'MICROSOFT'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    resolvedLabel() {
      return this.label || this.$t('common.seats');
    },
    resolvedPlaceholder() {
      return this.placeholder || this.$t('common.searchAllSeats');
    }
  },

  data() {
    return {
      selected: null,
      seats: []
    }
  },

  methods: {
    fetchSeats({search}) {
      let list = listMicrosoftSeats;
      if (this.providerTenant === 'GOOGLE') {
        list = listGoogleSeats;
      } else if (this.providerTenant === 'DROPBOX') {
        list = listDropboxSeats;
      } else if (this.providerTenant === 'BOX') {
        list = listBoxSeats;
      } else if (this.providerTenant === 'ENTRAID') {
        list = listEntraIdSeats;
      }

      return list({
        pagination: {
          pageNumber: 1,
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then((data) => {
          return data
        })
    },
    onOpen() {
      this.$nextTick(this.scrollHighlightedIntoView)
    },
    onHighlight() {
      this.$nextTick(this.scrollHighlightedIntoView)
    },
    onKeydown(e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        this.$nextTick(this.scrollHighlightedIntoView)
      }
    },
    scrollHighlightedIntoView() {
      const picker = this.$refs.picker
      const wrapper = picker.$el.querySelector(
        '.multiselect__content-wrapper'
      )
      const highlighted = wrapper.querySelector(
        '.multiselect__option--highlight'
      )
      if (highlighted) {
        // scroll just enough to make it appear
        highlighted.scrollIntoView({block: 'nearest'})
      }
    }
  }
}
</script>

<style lang="scss">
@import "IUserMultiPicker";
</style>
